/**
 * Centralized filter IDs for Tasks Overview
 * These IDs are used both in filter hooks and in backend filters_config
 */

// Task type filter
export const TASK_TYPE_ID = "taskType" as const;

// Location filters
export const LOCATIONS_ID = "locations" as const;
export const PICKUP_LOCATIONS_ID = "pickupLocations" as const;
export const REFILL_LOCATIONS_ID = "refillLocations" as const;
export const GROUP_LOCATIONS_ID = "groupLocations" as const;

// Additional filters
export const GROUP_BY_ID = "groupBy" as const;
export const QUANTITY_TYPE_ID = "quantityType" as const;

// Sort filter
export const SORT_BY_ID = "sortedBy";
